class ScrollHandle {
  constructor(element) {
    if (element) {
      this._handle = element;
      this._targetElement = document.querySelector(this._handle.dataset.scrolltarget);

      this._handle.addEventListener('click', this._scroll.bind(this));
    }
  }

  _scroll() {
    const options = {
      top: this._targetElement.getBoundingClientRect().top - 80,
      behavior: 'smooth'
    };

    window.scroll(options);
  }

  init() {
    const scrollHandles = document.querySelectorAll('.scroll-handle');

    scrollHandles.forEach((el) => {
      new ScrollHandle(el);
    });
  }
}

export default new ScrollHandle;
